export default __webpack_public_path__ + "static/media/40t.b9744a3e.jpg";